// utils/toast.js
import { toast } from 'sonner';
import { getFriendlyErrorMessage } from './fetchErrorHandler';

export const showSuccess = (message) => {
  toast.success(message);
};

export const showError = (error) => {
  // Si es un error, obtener mensaje amigable
  const message = typeof error === 'string' 
    ? error 
    : getFriendlyErrorMessage(error, 'Ocurrió un error al procesar la solicitud');
  
  toast.error(message);
};

export const showWarning = (message) => {
  toast.warning(message);
};

export const showInfo = (message) => {
  toast.info(message);
};

export const showLoading = (message) => {
  return toast.loading(message);
};

export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};

export const showPromise = (promise, messages) => {
  return toast.promise(promise, {
    loading: messages.loading || 'Cargando...',
    success: messages.success || '✅ Completado',
    error: (err) => {
      // Si el error tiene mensaje amigable, usarlo
      if (err?.friendlyMessage) {
        return err.friendlyMessage;
      }
      if (err?.message) {
        return getFriendlyErrorMessage(err, messages.error || '❌ Error');
      }
      return messages.error || '❌ Error';
    },
  });
};